<template>
    <div v-if="data">
        <div class="text-right">
            <button class="btn btn-xs btn-default" @click="showDialog = true">
                <span class="fa fa-pencil"></span>
                Edit
            </button>

            <button class="btn btn-xs btn-danger" @click="confirmDelete">
                <span class="fa fa-trash"></span>
                Delete
            </button>
        </div>

        <OrderItemDialog
            v-if="showDialog"
            :orderItemId="data.id"
            @hide="showDialog = false"
            @saved="orderItemSaved"
            @deleted="orderItemDeleted"
            />
    </div>
</template>

<script>
export default {
    components: {
        OrderItemDialog: require('@/components/orderitems/OrderItemDialog.vue').default,
    },
    props: ['report', 'row', 'data'],
    data() {
        return {
            showDialog: false,
        };
    },
    methods: {
        orderItemSaved(id) {
            this.showDialog = false;

            let orderItem = this.$store.state.data.orderItems.byId[id];

            if (orderItem) {
                let index = this.report.meta.columns.findIndex(c => c.title.toLowerCase() == 'quantity');
                if (index > -1)
                    this.row.cells[index].value = orderItem.quantity;
                index = this.report.meta.columns.findIndex(c => c.title.toLowerCase() == 'notes');
                if (index > -1)
                    this.row.cells[index].value = orderItem.notes;
            }
        },
        confirmDelete() {
            swal({
                title: 'Delete this order item?',
                type: 'warning',
                showCancelButton: true,
            }).then(() => {
                axios.delete(`/api/orderitems/${this.data.id}`).then((response) => {
                    this.orderItemDeleted();
                }, (response) => {
                    swal('Error', 'Could not delete the order item', 'error');
                });
            });
        },
        orderItemDeleted() {
            let index = this.report.data.body.indexOf(this.row);
            if (index > -1)
                this.report.data.body.splice(index, 1);

            this.showDialog = false;
        },
    },
};
</script>
